module.exports = __webpack_public_path__ + "img/icon-currently.e8d2a9e9.svg";